export const change = (value, index, questionId) => ({
  type: 'FIB_CHANGE',
  index,
  questionId,
  value,
});

export const blur = (index, questionId) => ({
  type: 'FIB_BLUR',
  index,
  questionId,
});
